import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'

if (environment.production) {
  enableProdMode()
  const activateLogValue = localStorage.getItem('activateLog')
  if (activateLogValue !== 'true') {
    // window.console.log('console.log disabled.');
    window.console.log = () => {}
  }
} else {
  console.log('no production mode. console.log enabled')
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err))
